export default {
      id: "detailed-upload-usage",
      viewBox: "0 0 23 31",
      url: __webpack_public_path__ + "sprite.svg#detailed-upload",
      toString: function () {
        return this.url;
      }
    }